import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "../app/App";
import TextsPage from "../app/pages/TextsPage";
import "../app/styles/index.scss";

init();

export type AppConfig = {
  env: string;
  sign_out_url: string;
  flash?: { notice?: string; error?: string };
};

function init() {
  const lroot = document.getElementById("landing-root");
  if (lroot) {
    const root = createRoot(lroot);
    root.render(<TextsPage user={null} />);
    return;
  }

  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
    return;
  }

  console.warn("No root element found");
}
